import { useMemo } from 'react'
import { Box } from '@mui/material'
import { getUserStoreInfo } from 'utils/authService'
import { formatUIDateTime } from 'utils/helpers'
import { Table } from '@fullscreendigital/carrefour-dex-fe'
import s from './PrintDocument.modules.scss'
import { getColumns, getRows } from '../helpers'

const PrintDocument = props => {
  const { componentRef, reportDate, metiReport } = props

  const columns = useMemo(() => getColumns(), [])

  return (
    <div style={{ display: 'none' }}>
      <Box ref={componentRef}>
        <Box className={s.titleContainer}>
          <span className={s.locationName}>{getUserStoreInfo()?.storeName}</span>
          <span className={s.title}>Editare detaliata miscari de regularizare</span>
          <span className={s.date}>
            {/*{formatUIDateTime(reportDate)}*/}
          </span>
        </Box>
        <Box className={s.tablesContainer}>
          {metiReport.map(category => (
            <Box className={s.tableContainer}>
              <Box className={s.categoryName}>{category.categoryName}</Box>
              <Table
                hideCheckbox={true}
                isLoading={false}
                columns={columns}
                rows={[
                  ...category?.articles,
                  ...getRows(category)
                ]}
                disablePagination
                classes={{ headerClass: s.metiReportHeader, rowClass: s.metiReportRow }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  )
}

export default PrintDocument
